
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#990ae3"}},[_c('path',{attrs:{"d":"M13.632 6.664l.47-.473a3.042 3.042 0 00-4.3-4.301l-.47.471 4.3 4.3zM12.022 8.276l-4.303-4.3-5.035 5.037a3 3 0 00-.84 1.627l-.826 3.287a.84.84 0 00.837 1.072 1.469 1.469 0 00.216-.023l3.284-.823a3.027 3.027 0 001.63-.84l.47-.47 4.567-4.567z"}})])])
          )
        }
      }
    